"use strict";
/**
 * Created by rouven on 15.03.17.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
// @ts-ignore
var react_loading_1 = __importDefault(require("@wikom/react-loading"));
var actions_1 = require("../actions");
/**
 * accepts assoc objects and arrays, returns type of data
 * @param data
 * @param prependData
 * @param appendData
 */
var mergeData = function (data, prependData, appendData) {
    if (prependData === void 0) { prependData = null; }
    if (appendData === void 0) { appendData = null; }
    if (typeof data != "object" || typeof prependData != "object" || typeof appendData != "object")
        return data;
    if (Array.isArray(data)) {
        prependData = Array.isArray(prependData) ? prependData : [];
        appendData = Array.isArray(appendData) ? appendData : [];
        return prependData.concat(data, appendData);
    }
    return Object.assign({}, prependData, data, appendData);
};
/**
 *
 * @param Child
 * @param state
 * @param dataProp
 * @param isLoadingProp
 * @param name
 * @param dataMap
 * @param prependData
 * @param appendData
 * @param rest
 * @return {*}
 */
var mapChildren = function (Child, state, dataProp, isLoadingProp, name, dataMap, prependData, appendData, rest) {
    var _a;
    if (prependData === void 0) { prependData = null; }
    if (appendData === void 0) { appendData = null; }
    var storeData = state.data && state.data[name] || [];
    var isLoading = !state.queries[name] || state.queries[name].isPending === true;
    var data = (typeof dataMap == 'function' && storeData instanceof Array) ?
        storeData.map(dataMap) :
        storeData;
    data = mergeData(data, prependData, appendData);
    return react_1["default"].cloneElement(Child, __assign((_a = {}, _a[isLoadingProp] = isLoading, _a[dataProp] = isLoading ? null : data, _a.pagination = state.data && state.data.pagination && state.data.pagination[name] || null, _a), rest));
};
var mapStateToProps = function (state, _a) {
    var children = _a.children, name = _a.name, url = _a.url, force = _a.force, dataProp = _a.dataProp, isLoadingProp = _a.isLoadingProp, refresh = _a.refresh, dataMap = _a.dataMap, prependData = _a.prependData, appendData = _a.appendData, rest = __rest(_a, ["children", "name", "url", "force", "dataProp", "isLoadingProp", "refresh", "dataMap", "prependData", "appendData"]);
    return ({
        isLoading: !state.queries[name] || state.queries[name].isPending === true,
        refresh: refresh || (state.queries[name] && state.queries[name].isQueued === true),
        force: force || !state.queries[name] || state.queries[name].isComplete === false,
        children: react_1["default"].Children.map(children, function (Child) { return mapChildren(Child, state, dataProp, isLoadingProp, name, dataMap, prependData, appendData, rest); })
    });
};
var mapDispatchToProps = function (dispatch) { return ({
    loadData: function (_a) {
        var name = _a.name, url = _a.url;
        return dispatch((0, actions_1.loadData)({ name: name, url: url }));
    },
    clearData: function (_a) {
        var name = _a.name;
        return dispatch((0, actions_1.clearData)({ name: name }));
    }
}); };
var connector = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps);
/**
 * This is the main component.  It is responsible for loading the data into its children (passing it via props),also it handles the loading bar.
 * It is not responsible for loading the data into the state, nor is it responsiblefor updating the data in the state, although it might call the
 * loadData action responsible for loading data.
 */
var DataProvider = /** @class */ (function (_super) {
    __extends(DataProvider, _super);
    function DataProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataProvider.prototype.componentDidMount = function () {
        if (this.props.force) {
            this._pendingFetch = this.props.loadData({ name: this.props.name, url: this.props.url });
        }
    };
    DataProvider.prototype.componentWillReceiveProps = function (nextProps) {
        if ((this.props.force && this.props.url !== nextProps.url) || nextProps.refresh === true) {
            if (this._pendingFetch) {
                this._pendingFetch.cancel();
            }
            this.props.clearData({ name: this.props.name });
            this._pendingFetch = this.props.loadData({ name: nextProps.name, url: nextProps.url });
        }
    };
    DataProvider.prototype.componentWillUnmount = function () {
        this._pendingFetch && this._pendingFetch.cancel();
        if (this.props.force) {
            this.props.clearData({ name: this.props.name });
        }
    };
    DataProvider.prototype.render = function () {
        return this.props.onlyLoaded && this.props.isLoading
            ? react_1["default"].createElement("span", null, this.props.loading)
            : react_1["default"].createElement("span", null, this.props.children);
    };
    return DataProvider;
}(react_1.Component));
//@ts-ignore
var DataProviderContainer = connector(DataProvider);
var DataProviderWrapper = function (_a) {
    var name = _a.name, url = _a.url, _b = _a.dataProp, dataProp = _b === void 0 ? 'data' : _b, _c = _a.isLoadingProp, isLoadingProp = _c === void 0 ? 'isLoading' : _c, _d = _a.loading, loading = _d === void 0 ? react_1["default"].createElement(react_loading_1["default"], null) : _d, _e = _a.force, force = _e === void 0 ? false : _e, _f = _a.refresh, refresh = _f === void 0 ? false : _f, _g = _a.onlyLoaded, onlyLoaded = _g === void 0 ? false : _g, _h = _a.dataMap, dataMap = _h === void 0 ? null : _h, rest = __rest(_a, ["name", "url", "dataProp", "isLoadingProp", "loading", "force", "refresh", "onlyLoaded", "dataMap"]);
    return (react_1["default"].createElement(DataProviderContainer, __assign({ url: url, name: name, dataProp: dataProp, isLoadingProp: isLoadingProp, loading: loading, force: force, refresh: refresh, onlyLoaded: onlyLoaded, dataMap: dataMap }, rest)));
};
exports["default"] = DataProviderWrapper;
